import {googleAnalyticMixin} from '../mixins/component-mixins';

const gaTrackableButton = {
    template: '#ga-trackable-button',
    mixins: [googleAnalyticMixin],
};

const gaTrackableLink = {
    template: '#ga-trackable-link',
    mixins: [googleAnalyticMixin],
};

function initGAComponents(app) {
    app.component('ga-trackable-button', gaTrackableButton);
    app.component('ga-trackable-link', gaTrackableLink);
};

export {initGAComponents};
